import { InsurerData } from './insurer-data.model';
import { VehicleDataModel } from './vehicle-data.model';
import { OwnerDataModel } from './owner-data/owner-data.model';
import { ContactDataModel } from './contact-data.model';
import { AgreementModel } from './agreement.model';
import { VehicleStateModel } from './vehicle-state.model';
import { InsuranceDataModel } from './insurance-data.model';
import { AdditionalDriverModel } from './owner-data/additional-driver.model';

export class CalculationData {
  insurer?: InsurerData;
  vehicle: VehicleDataModel;
  owner: OwnerDataModel;
  contact?: ContactDataModel;
  agreements?: AgreementModel[];
  vehicleState?: VehicleStateModel;
  insuranceData?: InsuranceDataModel;
  additionalDrivers?: AdditionalDriverModel[];
  discounts?: any;
  integrationParameters?: CalculationIntegrationParameter[];
}

export interface CalculationIntegrationParameter {
  parameterName: CalculationIntegrationParameterName;
  parameterValue: any;
}

export enum CalculationIntegrationParameterName {
  CUSTOMER_AGREEMENT_PHOTO = 'customerAgreementPhoto',
}
